import React, {useMemo} from "react"
import {makeStyles} from "@material-ui/core/styles"
import {Backdrop, Fade, Modal, Typography} from "@material-ui/core"
import {useStore} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import {nl2br} from "../common"

const useStyles = makeStyles((theme) => ({
  loading: {
    textAlign: `center`,
  },
  modal: {
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    zIndex: 100000000000,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `2px solid #000`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  typo: {
    [theme.breakpoints.down(`sm`)]: {
      fontSize: `0.75rem`,
    },
  },
}))

export default function LoadingModal() {
  const {t} = useTranslation()
  const classes = useStyles()
  const {
    store: {loadingModal, locale},
  } = useStore()
  const {title = t(`connectingCloud`), message = t(`loadingData`), error = ``, state = false} = loadingModal

  return useMemo(
    () => (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 0,
        }}
        open={state}
      >
        <Fade in={state}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">{nl2br(title)}</h2>
            <pre>
              <Typography className={classes.typo}>{nl2br(message)}</Typography>
              <Typography className={classes.typo}>{error}</Typography>
            </pre>
            <div className={classes.loading}>
              <img src={`images/loading.svg`} alt="Loading" />
            </div>
            {/* <CircleBar /> */}
          </div>
        </Fade>
      </Modal>
    ),
    [classes, loadingModal, locale],
  )
}
